/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {shallowEqual, useSelector} from 'react-redux'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage} from '../modules/auth'
import {RootState} from '../../setup'
import {App} from '../App'
import PortfolioPreviewPage from '../pages/Portfolio/PortfolioPreviewPage'
import PublicPortfolio from '../pages/Portfolio/PublicPortfolio'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const isAuthorized = useSelector<RootState>(({auth}) => auth.user, shallowEqual)
  return (
    <>
      <BrowserRouter basename={PUBLIC_URL}>
        <Routes>
          {/* Public portfolio route - no authentication required */}
          <Route path='/sharable/:token' element={<PublicPortfolio />} />
          
          <Route element={<App />}>
            <Route path='error/*' element={<ErrorsPage />} />
            <Route path='logout' element={<Logout />} />
            {isAuthorized ? (
              <>
                <Route path='/portfolio/preview' element={<PortfolioPreviewPage />} />
                <Route path='/*' element={<PrivateRoutes />} />
                <Route path='/login' element={<Navigate to='/' />} />
                {/* <Route index element={<Navigate to='/' />} /> */}
              </>
            ) : (
              <>
                <Route path='/*' element={<AuthPage />} />
                <Route index element={<Navigate to='/login' />} />
              </>
            )}
          </Route>
        </Routes>
      </BrowserRouter>
    </>
  )
}

export {AppRoutes}
